import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'use-intl';
import {
  PageHeader,
  Screen,
  ScreenBody,
  SectionHead,
  Stack,
} from '@leanin/ui';
import { identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { ChangePasswordClient } from './-components/ChangePasswordClient';
import { SessionsSection } from './-components/SessionList';
import { TwoFactorClient } from './-components/TwoFactorClient';

export const Route = createFileRoute('/_authed/settings/sessions/')({
  component: SettingsSessionsPage,
});

function SettingsSessionsPage() {
  const t = useTranslations('Settings');
  const query = useQuery({
    ...identityKeys.sessions(),
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        title={t('sessions.errorTitle')}
        message={t('sessions.loadError')}
      />
    );
  }
  if (query.isLoading) return null;
  return (
    <Screen>
      <ScreenBody gap="2xl">
        <PageHeader
          eyebrow={t('back.settings')}
          title={t('sessions.title')}
          back={{ label: t('back.settings'), href: '/settings' }}
        />
        <Stack gap="md">
          <SectionHead title={t('sessions.activeHeading')} />
          <SessionsSection />
        </Stack>

        <ChangePasswordClient />

        <TwoFactorClient />
      </ScreenBody>
    </Screen>
  );
}
